import { css } from 'lit';

export const planeInstallHintStyles = css`
  :host {
    display: block;
  }

  :host([hidden]) {
    display: none;
  }

  .hint {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: var(--space-2) var(--space-4);
    max-width: var(--page-width);
    margin: 0 auto;
    padding: var(--space-2) calc(var(--space-5) + var(--safe-right)) var(--space-2) calc(var(--space-5) + var(--safe-left));
    font-size: var(--font-size-md);
  }

  .band {
    background: var(--surface);
    border-bottom: var(--border-width) solid var(--border);
  }

  .band p::before {
    content: '';
    display: inline-block;
    width: var(--bullet-size);
    height: var(--bullet-size);
    margin-right: var(--space-3);
    background: var(--accent);
  }

  p {
    margin: 0;
  }

  .actions {
    display: flex;
    gap: var(--space-2);
  }
`;
